import { i18nConfig } from 'airkey-mfa-react';

const en = {
  translation: {
    ...i18nConfig.resources.en.translation,
    introBottomSheetHeaderLabel: 'Tap your Airkey card to verify',
  },
};

export default en;
